import { Block, styled } from "@sonos-inc/web-ui-core"

export const UnstyledBlockUl = styled(Block.withComponent("ul"))({
  listStyle: "none",
})

export const PAsBlock = Block.withComponent("p")
